import { makeStyles } from '@material-ui/core'
import React from 'react'

interface LogoProps {
  size?: 'small' | 'medium' | 'large'
  variant?: 'default' | 'dark'
  className?: string
  style?: React.CSSProperties
}

const Logo: React.FunctionComponent<LogoProps> = props => {
  const classes = useLogoStyles()
  const { size = 'medium', variant = 'default', className, style, ...rest } = props

  const styles: React.CSSProperties = {
    height: size === 'large' ? 60 : size === 'small' ? 32 : 44,
    width: 'auto',
    maxWidth: '100%',
    ...style,
  }

  return (
    <img
      alt="Logo"
      src={variant === 'dark' ? '/static/images/logo_wide_alt.svg' : '/static/images/logo_wide.svg'}
      style={styles}
      width={size === 'large' ? 260 : undefined}
      height={size === 'large' ? 60 : undefined}
      loading="eager"
      {...({ fetchPriority: 'high' } as any)}
      className={`${variant === 'dark' ? classes.logoClassDark : classes.logoClass} ${className || ''}`}
      {...rest}
    />
  )
}
export const useLogoStyles = makeStyles(theme => ({
  logoClass: {
    border: '1px solid #fff',
  },
  logoClassDark: {},
}))

export default Logo
